import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-499c0a17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cinema-detail__episodes-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "cinema__collection-pagination"
}
const _hoisted_3 = { class: "pagination-page" }
const _hoisted_4 = ["title", "onClick"]

import { PropType, computed, ref, watch, nextTick } from 'vue'
import CinemaImg from '@shared/components/CinemaImg.vue'
import { useScrollCollection } from '@shared/composable/cinema'
import { IconPageLeft } from '@xunlei/thunder-icon-vue'
import { useToggle } from '@shared/composable/base'
import SVGIcon from '@remote/components/SVGIcon.vue'
import Playing from '@remote/components/Playing.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  dramas: {
    type: Array as PropType<API_NFO.drama[]>,
    require: true,
    default: () => [],
  },
  nfo: {
    type: Object as PropType<API_NFO.NFO>,
    required: true,
  },
  activeId: {
    type: String as PropType<string>,
    required: true,
  },
  from: {
    type: String as PropType<Stat.CinemaFrom>,
    default: '',
  },
  playing: {
    type: Boolean,
  },
},
  emits: ['view'],
  setup(__props) {

const props = __props





const dramas = computed(() => props.dramas ?? [])

const { is: isShowAll, toggle } = useToggle({ defaultIs: false })

const episodeListNodeRef = ref<HTMLDivElement | null>(null)

const episodeListInnerNodeRef = ref<HTMLDivElement | null>(null)

const {
  isScrollLeftShow,
  isScrollRightShow,
  scrollLeft,
  scrollRight,
  scrollToActiveItem,
  pageIndex,
  pageTotal,
} = useScrollCollection(episodeListNodeRef, episodeListInnerNodeRef, true)

watch(() => dramas.value, (value) => {
  if (value) nextTick(scrollToActiveItem)
})

const calculateProgress = (drama: API_NFO.Drama) => {
  if (drama.play_seconds && drama.during) {
    const result = Math.floor((drama.play_seconds / drama.during) * 100)
    if (Number.isNaN(result)) return 0
    return result
  }
  return 0
}

const getEpisodeName = (drama: API_NFO.Drama) => {
  const episode = Number(drama.episode)
  if (episode) {
    return `第${episode}集`
  }
  return drama.file_name ?? ''
}

function onToggle () {
  toggle()
  if (!isShowAll.value) nextTick(scrollToActiveItem)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isShowAll) && (_unref(isScrollLeftShow) || _unref(isScrollRightShow)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(["pagination-left", { disabled: !_unref(isScrollLeftShow) }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(scrollLeft) && _unref(scrollLeft)(...args)))
          }, [
            _createVNode(_unref(IconPageLeft))
          ], 2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(pageIndex)) + "/" + _toDisplayString(_unref(pageTotal)), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["pagination-right", { disabled: !_unref(isScrollRightShow) }]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(scrollRight) && _unref(scrollRight)(...args)))
          }, [
            _createVNode(_unref(IconPageLeft))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "episodeListNodeRef",
      ref: episodeListNodeRef,
      class: "cinema-detail__episodes-list hide-scrollbar"
    }, [
      _createElementVNode("div", {
        ref_key: "episodeListInnerNodeRef",
        ref: episodeListInnerNodeRef,
        class: _normalizeClass({'cinema-detail__episodes': true, 'show-all': _unref(isShowAll)})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dramas), (drama) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["episode", {active: drama.file_id === __props.activeId}]),
            key: drama.file_id,
            title: `播放 ${getEpisodeName(drama)}`,
            onClick: ($event: any) => (_ctx.$emit('view', drama.file_id))
          }, [
            _createVNode(CinemaImg, {
              class: "horizontal",
              img: drama.poster_horizontal || drama.poster_vertical,
              "is-poster-show": true,
              progress: calculateProgress(drama)
            }, null, 8, ["img", "progress"]),
            (__props.playing && drama.file_id === __props.activeId)
              ? (_openBlock(), _createBlock(Playing, {
                  key: 0,
                  style: {position: 'absolute', bottom: '-10px'}
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(getEpisodeName(drama)), 1)
          ], 10, _hoisted_4))
        }), 128))
      ], 2)
    ], 512),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["toggle-show-all", {'show-all': _unref(isShowAll)}]),
      onClick: onToggle
    }, [
      _createVNode(SVGIcon, {
        name: "play-gloden",
        width: "11px",
        height: "14px"
      }),
      _createTextVNode(" " + _toDisplayString(_unref(isShowAll) ? '收起选集' : '展开更多选集'), 1)
    ], 2), [
      [_vShow, _unref(isShowAll) || _unref(isScrollLeftShow) || _unref(isScrollRightShow)]
    ])
  ]))
}
}

})